export type ComponentMap = {[name: string]: any}